const PrescriptionStatus = Object.freeze({
  PENDING: 'pending',
  SENT: 'sent',
  PAUSED: 'paused',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
})

export default PrescriptionStatus